<div class="container py-3">
  <h2 class="mb-3">NTRIP Server Admin</h2>

    <!-- All NTRIP Connections - Live (Admin View) -->
    <div *ngIf="isAdmin" class="subsection">
      <div class="d-flex justify-content-between align-items-center mb-2 subheader">
        <h4 class="m-0 subsection-title">All NTRIP Connections - Live (Admin View)</h4>
      </div>
      <div>
        <div *ngIf="loadingAllConnections" class="loading-state"><p>Loading all connections...</p></div>
        <div *ngIf="!loadingAllConnections && allNtripConnections.length === 0" class="no-connections"><p>No active NTRIP connections found in the system.</p></div>
        <div *ngIf="!loadingAllConnections && allNtripConnections.length > 0" class="connections-table">
          <table class="table">
            <thead>
              <tr>
                <th>Mountpoint</th>
                <th>Type</th>
                <th>ID</th>
                <th>Agent</th>
                <th>IP Address</th>
                <th>User</th>
                <th>Connected For</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let c of allNtripConnections">
                <td>{{ (c.mountpoint || '').startsWith('/') ? (c.mountpoint || '').substring(1) : (c.mountpoint || '') }}</td>
                <td>{{ ((c.type || '').toLowerCase() === 'listen') ? 'rover' : (((c.type || '').toLowerCase() === 'source') ? 'base' : c.type) }}</td>
                <td>{{ c.id }}</td>
                <td>{{ c.agent }}</td>
                <td>{{ c.ip }}</td>
                <td>{{ c.user }}</td>
                <td>{{ c.connectedFor }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <!-- Admin dashboard actions (rebuild/apply/restart) -->
  <div class="subsection mt-3">
    <app-admin-dashboard></app-admin-dashboard>
  </div>

  <!-- Caster log panels -->
  <div *ngIf="isAdmin" class="mt-3">
    <div *ngFor="let panel of logPanels" class="subsection mt-2">
      <div class="d-flex justify-content-between align-items-center mb-2 subheader">
        <h4 class="m-0 subsection-title">{{ panel.title }}</h4>
        <div class="d-flex gap-2">
          <button class="btn btn-primary btn-sm"
                  (click)="showLatestLog(panel)"
                  [disabled]="panel.loadingLatest">
            {{ panel.loadingLatest ? 'Loading...' : 'Show latest log' }}
          </button>
          <button class="btn btn-outline-primary btn-sm"
                  (click)="downloadAllLogs(panel)"
                  [disabled]="panel.downloading">
            {{ panel.downloading ? 'Preparing...' : 'Download all logs' }}
          </button>
        </div>
      </div>
      <div>
        <div class="small text-muted mb-1" *ngIf="panel.meta">{{ panel.meta }}</div>
        <div class="api-response log-content">
          <div *ngIf="panel.parsed.mode === 'table'" class="table-responsive log-table-wrap">
            <table class="table table-sm table-striped table-hover align-middle mb-0 log-table">
              <thead>
                <tr>
                  <th *ngFor="let h of panel.parsed.headers">{{ h }}</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let row of panel.parsed.rows">
                  <td *ngFor="let cell of row; let i = index"
                      [class.log-msg-col]="i === row.length - 1 && panel.type !== 'access'">{{ cell }}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <pre class="mb-0" *ngIf="panel.parsed.mode === 'text'">{{ panel.content }}</pre>
          <div *ngIf="panel.parsed.mode === 'empty'">Waiting for response...</div>
        </div>
      </div>
    </div>
  </div>
</div>
